import EditNoteIcon from '@mui/icons-material/EditNote'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'
import { Box, IconButton, Popover, TextField, Tooltip } from '@mui/material'
import React, { useState } from 'react'

type Props = {
  note: string
  onChange: (text: string) => void
}

// Icon trigger + popover text field. Shows an orange "!" when a note exists,
// a muted edit-note icon when empty. The draft is committed when the popover
// closes (so the list doesn't re-render on every keystroke).
export const NoteButton: React.FC<Props> = ({ note, onChange }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const [draft, setDraft] = useState(note)
  const has = note.trim().length > 0

  const open = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    setDraft(note)
    setAnchor(e.currentTarget)
  }
  const close = () => {
    onChange(draft)
    setAnchor(null)
  }

  return (
    <>
      <Tooltip title={has ? 'Notiz anzeigen / bearbeiten' : 'Notiz hinzufügen'}>
        <IconButton
          size="small"
          color={has ? 'warning' : 'default'}
          onClick={open}
        >
          {has
            ? (
              <PriorityHighIcon fontSize="small" />
              )
            : (
              <EditNoteIcon fontSize="small" />
              )}
        </IconButton>
      </Tooltip>
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Box sx={{ p: 1.5, width: 320 }} onClick={(e) => e.stopPropagation()}>
          <TextField
            autoFocus
            multiline
            minRows={3}
            fullWidth
            size="small"
            placeholder="Notiz für den Sprecher…"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
          />
        </Box>
      </Popover>
    </>
  )
}
